import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getVideoFileKey, getTokenDataArea2025, saveMediaFileArea2025 } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import { area } from '@src/utils/area';

const UploadVideo = ({ name, changeInputHandle, formData, languages }) => {
    const [uploadState, setUploadState] = useState(1);
    const [progress, setProgress] = useState(0);
    const flieWhiteList = ['mp4', 'mov', 'quicktime'];

    const fileRef = useRef();

    const clickUploadVideoFile = () => {
        const picFileDom = fileRef.current;

        picFileDom.click();
    };

    useEffect(() => {
        if (formData?.[name]) {
            setUploadState(3);

            return false;
        }
    }, [formData]);

    useEffect(async () => {
        const picFileDom = fileRef.current;

        picFileDom.addEventListener('change', async () => {
            // todo限制类型和尺寸 图片20M 视频200M
            const formData = new FormData();
            const file = picFileDom.files[0];
            const fileSize = file.size;
            const fileType = file.type.toLocaleLowerCase().split('/');
            const maxFileSize = 524288000; // 500M转换成b

            // 文件大小校验
            if (fileSize > maxFileSize) {
                Toast.show({
                    content: area[languages].videoSelf.waring1,
                });

                return false;
            }

            setUploadState(2);

            // 第一步获取token
            const result = await getTokenDataArea2025(name);
            const tokenList = result?.data?.token_list;
            const transaction_id = result?.data?.transaction_id;
            const { url, token } = tokenList.pop();

            formData.append('token', token);
            formData.append('file', file);
            // 第二步上传文件
            const fileResult = await getVideoFileKey(url, formData, (progressEvent) => {
                const { loaded, total } = progressEvent;
                const precentage = Math.floor((loaded * 100) / total);

                setProgress(precentage);
            });
            const fileKey = fileResult?.data?.key || '';

            // 第三步存入表单
            await saveMediaFileArea2025(name, {
                transaction_id,
                video: fileKey,
            });

            changeInputHandle(name, transaction_id);
            setUploadState(3);
        });
    }, []);

    return (
        <>
            <div className={styles.formVideoBox} onClick={clickUploadVideoFile}>
                <input ref={fileRef} accept={flieWhiteList.map((item) => `video/${item}`).join(',')} className={styles.formVideoUploadInput} type="file" />
                {uploadState === 1 && <div className={styles.formVideoButton}>{area[languages].video1.buttonText}</div>}
                {uploadState === 2 && (
                    <div className={styles.formVideoButton}>
                        {area[languages].video1.uploadText}...{progress}%
                    </div>
                )}
                {uploadState === 3 && <div className={styles.formVideoButton}>{area[languages].video1.uploadDoneText}</div>}
            </div>
            {uploadState === 2 && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
        </>
    );
};

UploadVideo.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    changeInputHandle: PropTypes.func,
    languages: PropTypes.string,
};

export default errorBoundary(UploadVideo);
